import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import TechSmithLogo from '../../img/techsmith-logo.svg';
import { useTranslation } from 'react-i18next';
import { ControlButton, TscButtonType } from '@techsmith/tsc-cloud-style-guide';
import Config from '../../../config/config';
import { getSearchParamsFromHref, redirectToUrl } from '../../../util/PageUtil';
import '../../styles/signed-out.less';
export const signedOutReasons = ['enterprise_login_required', 'sign_in_error'];
const getReason = () => {
    const reason = getSearchParamsFromHref().get('reason');
    return signedOutReasons.includes(reason !== null && reason !== void 0 ? reason : '') ? reason : 'default';
};
const getLoginUrl = () => {
    const raw = getSearchParamsFromHref().get('login_params');
    if (!raw) {
        return null;
    }
    const params = new URLSearchParams(raw);
    if (!params.get('client_id') || !params.get('redirect_uri')) {
        return null;
    }
    if (!Config.auth0BaseUrl) {
        return null;
    }
    const url = new URL('authorize', Config.auth0BaseUrl);
    url.search = params.toString();
    return url.toString();
};
const SignedOutPage = () => {
    const { t } = useTranslation();
    const reason = getReason();
    const loginUrl = (reason === 'enterprise_login_required' || reason === 'sign_in_error') ? getLoginUrl() : null;
    useEffect(() => {
        document.title = t('signedOut.pageTitle');
    }, []);
    return (_jsx("div", Object.assign({ className: "signed-out-page-container" }, { children: _jsxs("div", Object.assign({ className: "content-main signed-out" }, { children: [_jsx(TechSmithLogo, {}), _jsxs("section", Object.assign({ className: "message", "data-reason": reason }, { children: [_jsx("h1", Object.assign({ className: "message-title" }, { children: t(`signedOut.reasons.${reason}.title`) })), _jsx("div", Object.assign({ className: "message-text" }, { children: t(`signedOut.reasons.${reason}.body`) })), reason !== 'default' && signedOutReasons.includes(reason) && (loginUrl
                            ? (_jsx(ControlButton, { buttonType: TscButtonType.primary, label: t(`signedOut.reasons.${reason}.buttonText`), title: t(`signedOut.reasons.${reason}.buttonText`), className: "btn-sign-in", onClick: () => redirectToUrl(loginUrl) }))
                            : _jsx("div", Object.assign({ className: "message-text" }, { children: t(`signedOut.reasons.${reason}.noLoginParamsText`) }))), _jsxs("div", Object.assign({ className: "link-section" }, { children: [_jsx("a", Object.assign({ href: t('general.customerSupport_link') }, { children: t('signedOut.supportLinkText') })), _jsx("a", Object.assign({ href: t('general.techSmithWebsite_link') }, { children: t('signedOut.websiteLinkText') }))] }))] }))] })) })));
};
export default SignedOutPage;
